import { render } from "./BadgeField.vue?vue&type=template&id=35c7b05c"
import script from "./BadgeField.vue?vue&type=script&lang=js"
export * from "./BadgeField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BadgeField.vue"]])

export default __exports__